document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const navigation = document.querySelector('[data-main-nav]');
  if (menuButton && navigation) {
    menuButton.addEventListener('click', () => {
      const open = body.classList.toggle('menu-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
    navigation.addEventListener('click', () => {
      body.classList.remove('menu-open');
      menuButton.setAttribute('aria-expanded', 'false');
    });
  }

  const searchDrawer = document.querySelector('[data-search-drawer]');
  if (searchDrawer && typeof searchDrawer.showModal === 'function') {
    const searchInput = searchDrawer.querySelector('[data-predictive-search-input]');
    const searchResults = searchDrawer.querySelector('[data-predictive-search-results]');
    let searchTimer;
    let searchRequest;

    const closeSearch = () => {
      searchDrawer.close();
      body.classList.remove('search-drawer-open');
    };
    const openSearch = () => {
      if (!searchDrawer.open) searchDrawer.showModal();
      body.classList.add('search-drawer-open');
      window.setTimeout(() => searchInput.focus(), 80);
    };
    const resultGroup = (title, items, type) => {
      if (!items?.length) return null;
      const group = document.createElement('section');
      group.className = 'predictive-search__group';
      const heading = document.createElement('h3');
      heading.textContent = title;
      const list = document.createElement('div');
      list.className = 'predictive-search__list';
      items.slice(0, 4).forEach((item) => {
        const link = document.createElement('a');
        link.className = 'predictive-search__item';
        link.href = item.url;
        const tag = document.createElement('span');
        tag.textContent = type;
        const name = document.createElement('strong');
        name.textContent = item.title;
        link.append(tag, name);
        list.append(link);
      });
      group.append(heading, list);
      return group;
    };
    const runPredictiveSearch = async () => {
      const query = searchInput.value.trim();
      searchResults.replaceChildren();
      if (query.length < 2) return;
      searchResults.setAttribute('aria-busy', 'true');
      searchRequest?.abort();
      searchRequest = new AbortController();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const params = new URLSearchParams({ q: query, 'resources[type]': 'product,collection,page,article', 'resources[limit]': '4', 'resources[options][unavailable_products]': 'last' });
        const response = await fetch(`${root}search/suggest.json?${params}`, { signal: searchRequest.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Predictive search failed');
        const results = (await response.json()).resources?.results || {};
        const groups = [
          resultGroup('PRODUITS', results.products, 'PRODUIT'),
          resultGroup('COLLECTIONS', results.collections, 'COLLECTION'),
          resultGroup('PAGES', results.pages, 'PAGE'),
          resultGroup('CONSEILS', results.articles, 'ARTICLE')
        ].filter(Boolean);
        if (groups.length) searchResults.append(...groups);
        else {
          const empty = document.createElement('p');
          empty.className = 'predictive-search__empty';
          empty.textContent = 'Aucun résultat. Essayez un autre mot-clé.';
          searchResults.append(empty);
        }
      } catch (error) {
        if (error.name !== 'AbortError') searchResults.textContent = 'La recherche est momentanément indisponible.';
      } finally {
        searchResults.removeAttribute('aria-busy');
      }
    };

    document.querySelectorAll('[data-search-drawer-open]').forEach((button) => button.addEventListener('click', openSearch));
    searchDrawer.querySelector('[data-search-drawer-close]').addEventListener('click', closeSearch);
    searchDrawer.addEventListener('click', (event) => { if (event.target === searchDrawer) closeSearch(); });
    searchDrawer.addEventListener('close', () => body.classList.remove('search-drawer-open'));
    searchInput.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(runPredictiveSearch, 220);
    });
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || typeof drawer.showModal !== 'function') return;

  const drawerBody = drawer.querySelector('[data-cart-drawer-body]');
  const drawerFooter = drawer.querySelector('[data-cart-drawer-footer]');
  const drawerTotal = drawer.querySelector('[data-cart-drawer-total]');
  const drawerStatus = drawer.querySelector('[data-cart-drawer-status]');
  const shopRoot = window.Shopify?.routes?.root || '/';
  const currency = window.Shopify?.currency?.active || 'EUR';
  const money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency });

  const setStatus = (message) => {
    drawerStatus.textContent = message;
  };

  const updateCount = (count) => {
    document.querySelectorAll('.cart-count').forEach((badge) => {
      badge.textContent = String(count);
    });
    document.querySelectorAll('.header-action--cart').forEach((cartButton) => {
      cartButton.setAttribute('aria-label', `Panier, ${count} article${count > 1 ? 's' : ''}`);
    });
  };

  const animateCartFeedback = (source) => {
    const cartButton = document.querySelector('.header-action--cart');
    if (!cartButton) return;
    cartButton.classList.remove('is-cart-updated');
    void cartButton.offsetWidth;
    cartButton.classList.add('is-cart-updated');
    window.setTimeout(() => cartButton.classList.remove('is-cart-updated'), 900);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !source) return;
    const sourceRect = source.getBoundingClientRect();
    const cartRect = cartButton.getBoundingClientRect();
    const flight = document.createElement('span');
    flight.className = 'cart-add-flight';
    flight.setAttribute('aria-hidden', 'true');
    flight.style.setProperty('--flight-start-x', `${sourceRect.left + sourceRect.width / 2}px`);
    flight.style.setProperty('--flight-start-y', `${sourceRect.top + sourceRect.height / 2}px`);
    flight.style.setProperty('--flight-end-x', `${cartRect.left + cartRect.width / 2}px`);
    flight.style.setProperty('--flight-end-y', `${cartRect.top + cartRect.height / 2}px`);
    flight.style.setProperty('--flight-mid-x', `${(sourceRect.left + sourceRect.width / 2 + cartRect.left + cartRect.width / 2) / 2}px`);
    flight.style.setProperty('--flight-arc-y', `${Math.min(sourceRect.top + sourceRect.height / 2, cartRect.top + cartRect.height / 2) - 90}px`);
    document.body.append(flight);
    window.requestAnimationFrame(() => flight.classList.add('is-flying'));
    window.setTimeout(() => flight.remove(), 720);
  };

  const iconButton = (label, symbol, action, key) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cart-drawer__quantity-button';
    button.setAttribute('aria-label', label);
    button.dataset.cartAction = action;
    button.dataset.cartKey = key;
    button.textContent = symbol;
    return button;
  };

  const renderCart = (cart) => {
    drawerBody.replaceChildren();
    updateCount(cart.item_count);
    drawerFooter.hidden = cart.item_count === 0;
    drawerTotal.textContent = money.format(cart.total_price / 100);

    if (cart.item_count === 0) {
      const empty = document.createElement('div');
      empty.className = 'cart-drawer__empty';
      const title = document.createElement('h3');
      title.textContent = 'PRÊT POUR LA PROCHAINE ATTAQUE ?';
      const text = document.createElement('p');
      text.textContent = 'Votre panier est vide. Découvrez nos leurres conçus pour déclencher l’instinct.';
      const link = document.createElement('a');
      link.className = 'btn';
      link.href = `${shopRoot}collections/all`;
      link.textContent = 'DÉCOUVRIR LES LEURRES';
      empty.append(title, text, link);
      drawerBody.append(empty);
      setStatus('Votre panier est vide.');
      return;
    }

    const list = document.createElement('div');
    list.className = 'cart-drawer__items';
    cart.items.forEach((item) => {
      const row = document.createElement('article');
      row.className = 'cart-drawer__item';

      const imageLink = document.createElement('a');
      imageLink.className = 'cart-drawer__image';
      imageLink.href = item.url;
      if (item.image) {
        const image = document.createElement('img');
        image.src = `${item.image}${item.image.includes('?') ? '&' : '?'}width=240`;
        image.alt = item.product_title;
        image.width = 120;
        image.height = 120;
        image.loading = 'lazy';
        imageLink.append(image);
      }

      const details = document.createElement('div');
      details.className = 'cart-drawer__item-details';
      const heading = document.createElement('a');
      heading.className = 'cart-drawer__item-title';
      heading.href = item.url;
      heading.textContent = item.product_title;
      details.append(heading);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.className = 'cart-drawer__variant';
        variant.textContent = item.variant_title;
        details.append(variant);
      }

      const controls = document.createElement('div');
      controls.className = 'cart-drawer__item-controls';
      const quantity = document.createElement('div');
      quantity.className = 'cart-drawer__quantity';
      quantity.append(
        iconButton(`Réduire la quantité de ${item.product_title}`, '−', 'decrease', item.key),
        Object.assign(document.createElement('span'), { textContent: String(item.quantity) }),
        iconButton(`Augmenter la quantité de ${item.product_title}`, '+', 'increase', item.key)
      );
      const price = document.createElement('strong');
      price.textContent = money.format(item.final_line_price / 100);
      controls.append(quantity, price);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cart-drawer__remove';
      remove.dataset.cartAction = 'remove';
      remove.dataset.cartKey = item.key;
      remove.textContent = 'Retirer';
      details.append(controls, remove);
      row.append(imageLink, details);
      list.append(row);
    });
    drawerBody.append(list);
    setStatus(`${cart.item_count} article${cart.item_count > 1 ? 's' : ''} dans votre panier.`);
  };

  const loadCart = async () => {
    setStatus('Chargement du panier…');
    const response = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart request failed');
    renderCart(await response.json());
  };

  const openDrawer = async () => {
    if (!drawer.open) drawer.showModal();
    body.classList.add('cart-drawer-open');
    try {
      await loadCart();
    } catch {
      setStatus('Impossible de charger le panier.');
    }
  };

  const closeDrawer = () => {
    drawer.close();
    body.classList.remove('cart-drawer-open');
  };

  document.querySelectorAll('.header-action--cart').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer();
    });
  });

  drawer.querySelector('[data-cart-drawer-close]').addEventListener('click', closeDrawer);
  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });
  drawer.addEventListener('close', () => body.classList.remove('cart-drawer-open'));

  drawerBody.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-cart-action]');
    if (!control) return;
    const item = control.closest('.cart-drawer__item');
    const currentQuantity = Number(item?.querySelector('.cart-drawer__quantity span')?.textContent || 0);
    const action = control.dataset.cartAction;
    const quantity = action === 'increase' ? currentQuantity + 1 : action === 'decrease' ? Math.max(0, currentQuantity - 1) : 0;
    control.disabled = true;
    setStatus('Mise à jour du panier…');
    try {
      const response = await fetch(`${shopRoot}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: control.dataset.cartKey, quantity })
      });
      if (!response.ok) throw new Error('Cart update failed');
      renderCart(await response.json());
    } catch {
      control.disabled = false;
      setStatus('La mise à jour a échoué. Réessayez.');
    }
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const submit = event.submitter;
      if (!submit?.matches('.product-submit, .add')) return;
      event.preventDefault();
      if (submit) {
        submit.disabled = true;
        submit.classList.remove('is-added');
        submit.classList.add('is-adding');
      }
      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Add to cart failed');
        if (submit) {
          submit.classList.remove('is-adding');
          submit.classList.add('is-added');
        }
        await loadCart();
        animateCartFeedback(submit);
        await new Promise((resolve) => window.setTimeout(resolve, 650));
        if (!drawer.open) drawer.showModal();
        body.classList.add('cart-drawer-open');
      } catch {
        form.submit();
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.classList.remove('is-adding');
          window.setTimeout(() => submit.classList.remove('is-added'), 1400);
        }
      }
    });
  });
});
